import { createContainer } from 'react-sweet-state';

import { ACTIONS, CustomerMemberStore } from './CustomerMemberStore';

export const CustomerMemberStoreContainer = createContainer(CustomerMemberStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state, currentCustomerId }) => {
      if (state) {
        setState(state);
      }

      if (!currentCustomerId) {
        return;
      }
      dispatch(ACTIONS.init());
    },
  onUpdate:
    () =>
    ({ setState, dispatch }, { state, currentCustomerId }) => {
      if (state) {
        setState(state);
      }

      if (!currentCustomerId) {
        return;
      }
      dispatch(ACTIONS.init());
    },
});
